import { render, staticRenderFns } from "./FindPwd.vue?vue&type=template&id=e4b0f8aa&scoped=true&"
import script from "./FindPwd.vue?vue&type=script&lang=js&"
export * from "./FindPwd.vue?vue&type=script&lang=js&"
import style0 from "./FindPwd.vue?vue&type=style&index=0&id=e4b0f8aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b0f8aa",
  null
  
)

export default component.exports